// Candidate eligibility, shared with the server. These are not ranking weights.
const PRIMARY_LOCAL_RADIUS_KM = 50;
const FALLBACK_LOCAL_RADIUS_KM = 161;
// Discover's "How far" choices (docs/plans/DISCOVER_REDESIGN.md §3): Nearby,
// Short hop, Open to driving, Day trip. The server accepts only these.
const DISCOVER_RADIUS_OPTIONS_KM = [5, 25, 50, 160];
module.exports = { PRIMARY_LOCAL_RADIUS_KM, FALLBACK_LOCAL_RADIUS_KM, DISCOVER_RADIUS_OPTIONS_KM };
